import axiosInstance from "../../../axios";
// Makes an HTTP POST request to authenticate the admin and retrieve login data
export const getloginService = async (credentials) => {
  try {
    const response = await axiosInstance.post("/auth/admin", credentials);
    console.log(response?.data, "apiiiiiii")
    return response?.data;
  } catch (error) {
    return {error: error?.response?.data?.message};
  }
};

export const getUserDetails = async () => {
  try {
    const response = await axiosInstance.get("/auth/info");
    return response?.data;
  } catch (error) {
    return {error: error?.response?.data?.message};
  }
}